import { CustomFonts, device } from '@dermloop/ui/web/util';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { createGlobalStyle } from 'styled-components';

import App from './app/app';

const GlobalStyles = createGlobalStyle`
  
  html, body{
    margin: 0;
    
    font-size:12px;
    @media ${device.tablet} {
       font-size: 16px;
    }
    font-family: Inter, Helvetica, Arial, sans-serif;
  }
`;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <>
    <GlobalStyles />
    <CustomFonts />
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  </>,
);
